import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=afb55ae6&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"
import style0 from "../../theme/tabs.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Tabs.vue?vue&type=style&index=1&id=afb55ae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb55ae6",
  null
  
)

export default component.exports